import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["stroke"];
import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../tokens';
var Activity = function Activity(_ref) {
  var stroke = _ref.stroke,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 10H15L12.5 17.5L7.50002 2.5L5.00002 10H1.66669",
    stroke: stroke,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
Activity.defaultProps = {
  stroke: colors.brand.primary
};
process.env.NODE_ENV !== "production" ? Activity.propTypes = {
  stroke: PropTypes.string
} : void 0;
export default Activity;